/**
 * MoveOutDialog — Confirmation dialog for moving out (deactivating) a resident.
 *
 * Shared by the residents list (kebab → Move Out) and the resident profile page,
 * which is why it lives here rather than under resident-profile/ — same
 * arrangement as RelocateDialog. The list page previously used a native
 * window.confirm(); this replaced it so both entry points look the same and the
 * confirm step can be guided (a browser prompt is outside the DOM, so the help
 * guide can neither point at it nor observe it).
 *
 * The typing gate itself lives in ConfirmTypedDialog, shared with the bulk
 * move-out and bulk delete confirmations. This file owns only the wording and
 * the two help-guide anchors; it is the ONLY caller that sets them, because one
 * anchor id must match exactly one visible element.
 */

import ConfirmTypedDialog from '../../../../components/v2/ConfirmTypedDialog.jsx';

const MoveOutDialog = ({
  residentName,
  onClose, onConfirm, saving,
}) => (
  <ConfirmTypedDialog
    title="Move Out Resident"
    confirmLabel="Move Out"
    savingLabel="Moving Out…"
    onClose={onClose}
    onConfirm={onConfirm}
    saving={saving}
    /* Help-guide anchors (docs/INTERACTIVE_HELP_PLAN.md §5.2). The move-out flow
       spotlights the field, then the button once the word matches; the button is
       also the flow's context selector, so if it disappears without a write the
       guide steps back. */
    helpIdInput="move-out-dialog.confirm-input"
    helpIdConfirm="move-out-dialog.confirm"
  >
    <p style={{ margin: 0, lineHeight: 1.6 }}>
      Are you sure you want to move out <strong>{residentName}</strong>?
    </p>
    <p style={{ margin: 'var(--space-2) 0 0', color: 'var(--color-text-muted)', fontSize: 'var(--font-size-sm)' }}>
      This will deactivate the resident. Their devices and wellness assignments will no longer be active.
      You can move them back in later.
    </p>
  </ConfirmTypedDialog>
);

export default MoveOutDialog;
